import React from 'react';
import { createStore } from 'devextreme-aspnet-data';
import { useAuth } from  '../../contexts/auth'; 

import DataGrid, {
  Format,
  Column,
  Button,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  Lookup,
  Popup,
  Form,
  Editing,
  Selection,
  Summary,
  GroupItem,
  TotalItem,
  SearchPanel,
  Toolbar,
  Item
} from 'devextreme-react/data-grid';

import { useState, useEffect, useCallback} from "react";

import {Button as ToolbarButton} from 'devextreme-react/button';

import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';

const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Movimenti';

export default function CustomerOrderDetail(props) {

    var orderInvocingDetDataGridRef = React.createRef();

    const [currentRow, setCurrentRow] = useState(1);
    const [isRowSelected, setIsRowSelected] = useState(false);

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedIds, setSelectedIds] = useState();
    const [currentInvoice, setCurrentInvoice] = useState();

    const filterPayload = { 
        idSuper: props.data.key
    };

    const { user } = useAuth(); 

    const remoteDataSourceDue = createStore({
      key: 'id',
      loadUrl: serviceUrl2 + '/FindIncassiByRata',
    
      onBeforeSend: (method, ajaxOptions) => {
        if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
        }  
        ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
        ;
      },
      //loadUrl: serviceUrl2 + '/GetAction',
      //insertUrl: serviceUrl4 + '/InsertAction',
      //updateUrl:serviceUrl4 + '/UpdateAction',
      //deleteUrl: serviceUrl4 + '/DeleteAction'  
    });

    const hideEditButton = useCallback((e) => {
        return false;
      }, []);


    const getStringId = (row) => `${row.id}`;
    const getSelectedIds = (selectedRowsData) => (selectedRowsData.length ? selectedRowsData.map(getStringId).join(';') : '');

    const onSelectionChanged = useCallback(
      ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
        //setPrefix(null);
        setSelectedRowKeys(changedRowKeys);
        setSelectedIds(getSelectedIds(selectedRowsData));

        if(selectedRowsData.length)
          setIsRowSelected(true);
        else
          setIsRowSelected(false);

        const data = selectedRowsData[0];
        if (data !== null && data !== undefined) 
          setCurrentRow(data.id);

      }, [],
    );

    const showInvoiceIcon = useCallback((e) => {
      return e.row.data.fatturaClienteId !== null;
    }, []);

    const infoHint = "Fattura ";
    const infoIcon = 'file';

    function createInvoice() {
    
      let result = confirm("<i>Procedere con la creazione di una fattura a partire dai movimenti selezionati?</i>", "Crea Fattura");
      result.then((dialogResult) => { 
          if  (dialogResult) {
              creaFattura(selectedIds);
          } 
        //alert(e.row.data.id); 
      });
  }
  
  
  const creaFattura= (selectedIds) => {

    const movsPayload = { 
      rata: props.data.key,
      stringIds: selectedIds
    };

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/CreateFatturaClienteFromMovimenti';
  
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(movsPayload),
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
    
    return fetch(url, requestOptions)
        .then(response => {
        if(response.ok) return response.json();
            //Global.CheckResponseAuth(response);
            return null;
        })
        .then(data => { 
            ;
            setTimeout(() => { 
            notify(data.message, data.success ? 'success' : 'error', 2000);         
            }, 100);
            orderInvocingDetDataGridRef.instance().refresh();
        })
        .catch(error => { notify(error, 'error', 5000); }); 
  }

  return (

    <div>
      <DataGrid
        dataSource={remoteDataSourceDue}
        //focusedRowEnabled={true}
        //onCellPrepared={onCellPreparedDue}
        onSelectionChanged={onSelectionChanged}
        //onExporting={onExporting}
        //onToolbarPreparing = {onToolbarPreparing}
        ref={ref => orderInvocingDetDataGridRef = ref}
      >


      <SearchPanel visible={false} width={240} placeholder="Cerca..." />
      <HeaderFilter visible={false} />
      <Selection mode="multiple"  selectAllMode="page" showCheckBoxesMode="always"/>
        
      <Editing
        mode="popup"
        useIcons={true}
        allowAdding={false}
        allowDeleting={false}
        allowUpdating={false}     
      >    
      </Editing>

      <Toolbar>
        <Item location="after">
        <ToolbarButton className="offer-toolbar"
            icon='money'
            hint='Crea Fattura'
            onClick={createInvoice} 
            disabled={!isRowSelected}
        />
        </Item>
        
      </Toolbar>

      <Column dataField="id" caption="#" visible={false}/>
      
      <Column dataField="refId" caption="#" width={40} allowHeaderFiltering={true} allowEditing={false}/>        
      <Column dataField="descrizione" width={400} allowHeaderFiltering={false} allowEditing={false}/>
      <Column dataField="importoTotale" allowHeaderFiltering={false} caption="Importo Totale" allowEditing={false} >
        <Format type="fixedPoint" precision={2} allowHeaderFiltering={false}/>
      </Column>
      <Column dataField="importoRata" visible={true} allowHeaderFiltering={false} caption="Importo Rata" allowEditing={false} >
        <Format type="fixedPoint" precision={2} allowHeaderFiltering={false}/>
      </Column>
      
      <Column dataField="importoResiduo" visible={false} allowEditing={false} caption="Totale già pagato">
        <Format type="fixedPoint" precision={2} />
      </Column>
      <Column dataField="saldo" allowHeaderFiltering={false} allowEditing={false}>
        <Format type="fixedPoint" precision={2} />
      </Column>
      <Column dataField="dataPagamento" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={false}/>
      <Column dataField="numeroFatturaCliente" caption="N° Fattura" visible={true}/>
      <Column type="buttons">
          <Button name="invoice" icon = {infoIcon} hint = {infoHint} visible={showInvoiceIcon}/>
      </Column>
      
      </DataGrid>

    </div>  
  
  )
};
